module.exports = __webpack_public_path__ + "img/leef_leefmaincorp.6fe132c.png";